import { Stack, StackProps, styled, Typography } from "@mui/material";
import { TypographyOwnProps } from "@mui/material/Typography/Typography";
import { formatNumber } from "src/utils/formatting";
import { useTranslation } from "react-i18next";
import EmptySetIcon from "src/assets/icons/empty-set.svg?react";
import { MainScore } from "src/api/client-api/olapScores/olapScoresSchema";
import { OlapScoresService } from "src/context/OlapScores/OlapScoresService";

export type ScoreValueProps = StackProps & {
    variant?: TypographyOwnProps["variant"];
    score: MainScore;
    precision: number;
    align?: "left" | "center" | "right";
};

export const UnitStyled = styled(Typography)(({ theme }) => ({
    wordSpacing: "0.2rem",
    "> span:first-of-type": {
        fontSize: "0.75rem",
    },
    "> span": {
        fontSize: theme.typography.subtitle2,
        color: "#A3A2A0",
    },
    "> strong": {
        fontSize: "0.875rem",
        textDecoration: "none",
        fontWeight: 800,
    },
}));

export const ScoreValue = (props: ScoreValueProps) => {
    const { i18n } = useTranslation();
    const { score, align = "left", precision, ...stackProps } = props;

    const value = OlapScoresService.normalizeNumericalScore(score.score.value);

    return (
        <Stack
            direction="column"
            flexBasis="100%"
            alignItems={
                {
                    left: "flex-start",
                    center: "center",
                    right: "flex-end",
                }[align]
            }
            {...stackProps}
        >
            <Stack alignItems="center" gap="12px">
                <Stack alignItems="center" gap="10px">
                    <Typography
                        variant={props.variant}
                        sx={{
                            fontWeight: 800,
                            position: "relative",
                        }}
                    >
                        {value !== null ?
                            formatNumber(value, i18n.resolvedLanguage, {
                                maximumFractionDigits: precision,
                                minimumFractionDigits: precision,
                            })
                        :   <EmptySetIcon />}
                    </Typography>
                </Stack>
            </Stack>

            <UnitStyled
                variant="body"
                sx={{
                    position: "relative",
                    top: "-6px",
                }}
            >
                {score.unit}
            </UnitStyled>
        </Stack>
    );
};
